"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Libraries = void 0;
const server_sdk_1 = require("@air/server-sdk");
const types_1 = require("@air/types");
const querystring_1 = require("querystring");
const request_1 = require("./request");
const util_1 = require("./util");
/**
 * Create new Library
 */
function create({ workspaceId, library, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.libraries, {
        method: 'POST',
        body: library,
        workspaceId,
    });
}
/**
 * Get a Library
 */
function get({ workspaceId, libraryId, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.libraries, {
        method: 'GET',
        endpoint: `${libraryId}`,
        workspaceId,
    });
}
/**
 * List Libraries
 */
function list(args) {
    return (0, request_1.airRequest)(server_sdk_1.Libraries.list, { body: args });
}
/**
 * Update a Library
 */
function update({ workspaceId, libraryId, update, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.libraries, {
        endpoint: `${libraryId}/update`,
        method: 'PATCH',
        body: update,
        workspaceId,
    });
}
/**
 * Delete a library
 */
function del({ workspaceId, libraryId, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.libraries, {
        endpoint: `${libraryId}`,
        method: 'DELETE',
        workspaceId,
    });
}
/**
 * API to bulk fetch library details by provided libraryIds
 */
function listByIds(options) {
    return __awaiter(this, void 0, void 0, function* () {
        return (0, request_1.airRequest)(types_1.EndpointType.libraries, {
            endpoint: 'listByIds',
            method: 'POST',
            body: options,
            workspaceId: options.workspaceId,
        });
    });
}
/**
 * Gets a library's statistics (e.g. total assets, members & boards)
 * @param libraryId id of library
 * @param options
 *   onlyCoverVersions - only get total size of current cover asset versions (clips)
 */
function getStats({ workspaceId, libraryId, options, }) {
    const { onlyCoverVersions = false } = options || {};
    return (0, request_1.airRequest)(types_1.EndpointType.libraries, {
        endpoint: `${libraryId}/stats?${(0, querystring_1.stringify)({ onlyCoverVersions })}`,
        workspaceId,
    });
}
/**
 * Add a member(s) to a library
 * @param libraryId The library to add to
 * @param members List of new member information consisting of email and memberRole
 */
function addMembers({ workspaceId, libraryId, members, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.libraries, {
        method: 'POST',
        endpoint: `${libraryId}/members`,
        body: members,
        workspaceId,
    });
}
/**
 * Update a Library Member
 * @param libraryId The library in which the member is a part of
 * @param member The library member to update
 */
function updateMember({ workspaceId, libraryId, member, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.libraries, {
        endpoint: `${libraryId}/members`,
        method: 'PATCH',
        body: member,
        workspaceId,
    });
}
/**
 * Remove member(s) from a library
 * @param libraryId The library to add to
 * @param members List of members to remove from library
 */
function removeMembers({ workspaceId, libraryId, members, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.libraries, {
        method: 'DELETE',
        endpoint: `${libraryId}/members`,
        body: members,
        workspaceId,
    });
}
/**
 * List library members
 */
function listMembers({ workspaceId, libraryId, options, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.libraries, {
        method: 'GET',
        endpoint: `${libraryId}/members?${(0, util_1.formatParamsForHttp)(options)}`,
        workspaceId,
    });
}
/**
 * get (hidden) library custom fields
 */
function listCustomFields(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, libraryId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.libraries, {
            method: 'GET',
            endpoint: `${libraryId}/customFields`,
            workspaceId,
        });
    });
}
/**
 * update (hidden) library custom fields
 * @param visible boolean - whether or not to show/hide custom field
 */
function updateCustomFields(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, libraryId, customFields, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.libraries, {
            method: 'PATCH',
            endpoint: `${libraryId}/customFields/`,
            body: { customFields },
            workspaceId,
        });
    });
}
exports.Libraries = Object.assign(Object.assign({}, (0, util_1.sdkToApi)(server_sdk_1.Libraries)), { create,
    get,
    list,
    update,
    listByIds,
    del,
    getStats,
    addMembers,
    listMembers,
    updateMember,
    removeMembers,
    listCustomFields,
    updateCustomFields });
//# sourceMappingURL=libraries.js.map